import NError from './NError.vue'
export default NError;